import React from 'react';
/**
 * Used to control where data areas appear and how photos are treated
 */

export var PropertyCardContext = /*#__PURE__*/React.createContext({});
export var PropertyCardProvider = PropertyCardContext.Provider;